'use client';
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DEFAULT_CURRENCY_CODE } from '../../constants/defaults';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const CurrencySelect = ({ name, label, control, errors, readOnly = false, helperText, onChange }) => {
  const { common } = useTranslatedMessages();
  const currencySelect = common.currency_select ?? {};
  const resolvedLabel = label ?? currencySelect.label;
  const currenciesList =
    useSelector((state) => {
      return state?.codeLists?.currenciesList;
    }) ?? [];

  // Find the currency object by code
  const getCurrencyByCode = (code) => {
    return currenciesList.find((c) => c.code === code);
  };

  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage].filter(Boolean).join(' * ');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedCurrency = getCurrencyByCode(field.value) ?? getCurrencyByCode(DEFAULT_CURRENCY_CODE) ?? null;
        return (
          <Autocomplete
            options={currenciesList}
            getOptionLabel={(option) => option.code}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            value={selectedCurrency}
            onChange={(_, selected) => {
              const newCode = selected?.code || DEFAULT_CURRENCY_CODE;
              field.onChange(newCode);
              onChange?.(newCode);
            }}
            disableClearable={readOnly}
            readOnly={readOnly}
            renderOption={(props, option) => (
              <li {...props} key={option.code}>
                {option.code} - {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={resolvedLabel}
                sx={{ minWidth: '150px' }}
                error={!!errorMessage}
                helperText={combinedHelperText || ''}
              />
            )}
          />
        );
      }}
    />
  );
};

export default CurrencySelect;
